import baseRoute from '../baseRoute';

export type * from './viewModel';
export type * from './queryParams';

type BaseRouteDefinition = `${typeof baseRoute}/group/${number | ':groupId'}/category`;

type QueryRouteDefinition = `${typeof baseRoute}/group/${number | ':groupId'}/category${`?year=${string}` | ''}`;

type RouteDefinition = BaseRouteDefinition | QueryRouteDefinition;

export const ROUTE: RouteDefinition = `${baseRoute}/group/:groupId/category`;

export const URL = (groupId: number, year?: string): RouteDefinition => year
	? `${baseRoute}/group/${groupId}/category?year=${year}`
	: `${baseRoute}/group/${groupId}/category`;
